import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import {Card} from "../../../../../../components/card/card.jsx";
import {useFormContext} from "react-hook-form";
import projectUtils from "../../../../../../utils/project-utils.js";
import CftvMap from "./cftv-map.jsx";

const CftvForm = () => {
    const {watch, setValue} = useFormContext();
    const integrations = watch("integrations") ?? [];
    const latitudeValue = watch("capturePlace.latitude");
    const longitudeValue = watch("capturePlace.longitude");
    const laneCode = watch("lane.code");
    const latitude = Number(latitudeValue);
    const longitude = Number(longitudeValue);
    const hasValidCoordinates = latitudeValue !== "" && latitudeValue != null
        && longitudeValue !== "" && longitudeValue != null
        && Number.isFinite(latitude) && latitude >= -90 && latitude <= 90
        && Number.isFinite(longitude) && longitude >= -180 && longitude <= 180;

    const findIntegration = (camera) => integrations.find(item =>
        Number(item.id) === Number(camera.id) && Number(item.vmsId) === Number(camera.vmsId));

    const associate = (camera, offset) => {
        if (findIntegration(camera)) {
            projectUtils.swalErrorMessage("", "A câmera já está associada à faixa");
            return;
        }

        const integration = {
            id: Number(camera.id),
            name: camera.name,
            offset: Number(offset),
            vmsName: camera.vmsName ?? "",
            vmsId: Number(camera.vmsId),
            vmsUrl: camera.vmsUrl ?? "",
        };

        setValue("integrations", [...integrations, integration], {shouldDirty: true});
    };

    const remove = (camera) => {
        setValue("integrations", integrations.filter(item =>
            Number(item.id) !== Number(camera.id) || Number(item.vmsId) !== Number(camera.vmsId)), {shouldDirty: true});
    };

    const updateOffset = (camera, offset) => {
        setValue("integrations", integrations.map(item =>
            Number(item.id) === Number(camera.id) && Number(item.vmsId) === Number(camera.vmsId)
                ? {...item, offset: Number(offset)}
                : item), {shouldDirty: true});
    };

    return (
        <Card className="h-full border-none!">
            <Card.Body className={"p-0!"}>
                <SentryRow>
                    <div className="col-span-12">
                        {hasValidCoordinates
                            ? <CftvMap
                                center={{lat: latitude, lng: longitude}}
                                laneCode={laneCode}
                                integrations={integrations}
                                onAssociate={associate}
                                onRemove={remove}
                                onOffsetChange={updateOffset}
                            />
                            : <div className="flex min-h-[320px] items-center justify-center rounded border border-amber-300 bg-amber-50 p-6 text-center text-sm text-amber-800">
                                Informe uma latitude e longitude válidas em “Ponto de coleta + Sentido” para localizar as câmeras de vídeo próximas.
                            </div>}
                    </div>
                </SentryRow>
            </Card.Body>
        </Card>
    );
};

export default CftvForm;
